import { h } from "preact";
import { Route, Router } from "preact-router";

// Code-splitting is automated for `routes` directory
import Home from "../routes/home";
import { Credits } from "./credits";
import Header from "./Header";
import MenuItem from "./MenuItem";
import Menu from "./Menu";
import Logo from "./Logo";
import Page from "./Page";
import Timelapse from "../routes/timelapse";
import About from "../routes/about";
import Flash from "./Flash";
import ChartsPage from "../routes/charts";
import TestPage from "../routes/test";

const App = () => (
  <div id="app">
    <main>
      {/* One row: logo, menu, slogan. The player is the tall thing on this site and
          the header used to push it below the fold on a laptop. */}
      <Header>
        <Logo />
        <Menu>
          {/* The front page's camera is the timelapse player in combined mode, so
              /timelapse has no tab of its own; the route stays for share links. */}
          <MenuItem href="/">Webcams</MenuItem>
          <MenuItem href="/charts">Weather</MenuItem>
          <MenuItem href="/about">About Us</MenuItem>
        </Menu>
        <Flash />
      </Header>
      <Page>
        <Router>
          <Route path="/" component={Home} />
          <Route path="/timelapse" component={Timelapse} />
          <Route path="/timelapse/:code" component={Timelapse} />
          <Route path="/charts" component={ChartsPage} />
          <Route path="/about" component={About} />
          <Route path="/test" component={TestPage} />
        </Router>
      </Page>
      <Credits />
    </main>
  </div>
);

export default App;
